import {Async, Empty, Loading} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {AgentWithConnections} from 'Users/models/Agent';

enum AgentProfileActionType {
  FETCH_AGENT_PROFILE = 'agentProfile/FETCH',
  CHANGE_AGENT_PROFILE = 'agentProfile/CHANGE_AGENT_PROFILE',
}

export const fetchAgentProfile = (agentId: number) =>
  createAction(AgentProfileActionType.FETCH_AGENT_PROFILE, {agentId});
export const changeAgentProfile = (agent: Async<AgentWithConnections>) =>
  createAction(AgentProfileActionType.CHANGE_AGENT_PROFILE, agent);

type AgentProfileState = {
  agent: Async<AgentWithConnections>;
};

export const DEFAULT_STATE: AgentProfileState = {
  agent: new Empty(),
};

type AgentProfileActions = ReturnType<typeof fetchAgentProfile> | ReturnType<typeof changeAgentProfile>;

export default (state: AgentProfileState = DEFAULT_STATE, action: AgentProfileActions): AgentProfileState => {
  switch (action.type) {
    case AgentProfileActionType.FETCH_AGENT_PROFILE:
      return {
        ...state,
        agent: new Loading(),
      };
    case AgentProfileActionType.CHANGE_AGENT_PROFILE:
      return {
        ...state,
        agent: action.payload,
      };
    default:
      return state;
  }
};
